import type {
  AccessRequest,
  CanonicalCatalogItem,
  CatalogSearchResult,
  CommercialAccess,
  MappingRecord,
  PlatformSupplierIntegration,
  SupportGrant,
  TenantSupplierSummary,
  TenantUser,
} from '../domain/models.js';

// DEVELOPMENT/MOCK FIXTURES ONLY. Replace through the repository boundary.
const r28003: CanonicalCatalogItem = {
  id: 'canonical-r28003-fipar',
  article: 'R28003',
  name: 'Fipar Grand Classic R28003',
  brand: 'Fipar',
  collection: 'Grand Classic',
  unit: 'рул',
  texture: 'floral',
  supplierCount: 4,
  warehouseCount: 5,
  offers: [
    {
      id: 'r-surgaz-main',
      supplierId: 'surgaz',
      supplierName: 'Surgaz',
      supplierSku: 'R28003 / 10004512',
      warehouse: 'Москва',
      lot: 'Партия 24-08',
      purchase: { amount: 1420, currency: 'RUB' },
      rrp: { amount: 2390, currency: 'RUB' },
      free: { amount: 12, unit: 'рул' },
      expected: { amount: 24, unit: 'рул' },
      freshness: 'current',
      freshnessLabel: 'Актуально',
      freshnessDetail: 'Получено через API поставщика 12 августа 2026, 09:42. Значения подтверждены текущей загрузкой.',
      observedAt: '12.08.2026 09:42',
    },
    {
      id: 'r-surgaz-second',
      supplierId: 'surgaz',
      supplierName: 'Surgaz',
      supplierSku: 'R28003 / 10004512',
      warehouse: 'Санкт-Петербург',
      purchase: { amount: 1420, currency: 'RUB' },
      rrp: { amount: 2390, currency: 'RUB' },
      free: { amount: 0, unit: 'рул' },
      expected: { amount: 8, unit: 'рул' },
      freshness: 'current',
      freshnessLabel: 'Актуально',
      freshnessDetail: 'Получено через API поставщика 12 августа 2026, 09:42. Нулевой остаток подтверждён источником.',
      observedAt: '12.08.2026 09:42',
    },
    {
      id: 'r-supplier-b',
      supplierId: 'supplier-b',
      supplierName: 'Поставщик B',
      supplierSku: 'FIP-R28003',
      warehouse: 'Основной склад',
      purchase: { amount: 1480, currency: 'RUB' },
      rrp: { amount: 2450, currency: 'RUB' },
      free: { amount: 9, unit: 'рул' },
      expected: { amount: 15, unit: 'рул' },
      freshness: 'current',
      freshnessLabel: 'Актуально',
      freshnessDetail: 'Получено 12 августа 2026, 09:31. Импорт завершён без ошибок.',
      observedAt: '12.08.2026 09:31',
    },
    {
      id: 'r-supplier-c',
      supplierId: 'supplier-c',
      supplierName: 'Поставщик C',
      supplierSku: 'R-28003',
      warehouse: 'Склад 1',
      purchase: { amount: 1390, currency: 'RUB' },
      rrp: { amount: 2300, currency: 'RUB' },
      free: { amount: 7, unit: 'рул' },
      expected: { amount: null, unit: 'рул' },
      freshness: 'stale',
      freshnessLabel: 'Устарело',
      freshnessDetail: 'Последнее успешное обновление 12 августа 2026, 07:08. Значения показаны как последние известные.',
      observedAt: '12.08.2026 07:08',
    },
    {
      id: 'r-supplier-d',
      supplierId: 'supplier-d',
      supplierName: 'Поставщик D',
      supplierSku: 'GC-R28003',
      warehouse: 'Склад D1',
      purchase: { amount: 1410, currency: 'RUB' },
      rrp: { amount: null, currency: 'RUB' },
      free: { amount: 5, unit: 'рул' },
      expected: { amount: null, unit: 'рул' },
      freshness: 'source_error',
      freshnessLabel: 'Ошибка источника',
      freshnessDetail: 'Текущая загрузка завершилась ошибкой. Показаны последние успешные данные от 11 августа 2026, 18:20.',
      observedAt: null,
      lastSuccessAt: '11.08.2026 18:20',
    },
  ],
};

const a7712Alpha: CanonicalCatalogItem = {
  id: 'canonical-a7712-alpha',
  article: 'A7712',
  name: 'Wallpaper Alpha',
  brand: 'Alfa Decor',
  collection: 'Linea',
  unit: 'рул',
  texture: 'lines',
  duplicateWarning: 'Одинаковый артикул найден у нескольких канонических товаров',
  supplierCount: 2,
  warehouseCount: 2,
  offers: [
    {
      id: 'a-alpha-surgaz',
      supplierId: 'surgaz',
      supplierName: 'Surgaz',
      supplierSku: 'A7712 / ALPHA',
      warehouse: 'Москва',
      purchase: { amount: 1560, currency: 'RUB' },
      rrp: { amount: 2450, currency: 'RUB' },
      free: { amount: 6, unit: 'рул' },
      expected: { amount: 10, unit: 'рул' },
      freshness: 'current',
      freshnessLabel: 'Актуально',
      freshnessDetail: 'Получено 12 августа 2026, 09:42. Товар сопоставлен с выбранной канонической карточкой.',
      observedAt: '12.08.2026 09:42',
    },
    {
      id: 'a-alpha-b',
      supplierId: 'supplier-b',
      supplierName: 'Поставщик B',
      supplierSku: 'A7712-A',
      warehouse: 'Основной склад',
      purchase: { amount: 1610, currency: 'RUB' },
      rrp: { amount: 2520, currency: 'RUB' },
      free: { amount: 4, unit: 'рул' },
      expected: { amount: null, unit: 'рул' },
      freshness: 'stale',
      freshnessLabel: 'Устарело',
      freshnessDetail: 'Последнее успешное обновление 12 августа 2026, 06:58.',
      observedAt: '12.08.2026 06:58',
    },
  ],
};

const a7712Beta: CanonicalCatalogItem = {
  id: 'canonical-a7712-beta',
  article: 'A7712',
  name: 'Wallpaper Beta',
  brand: 'Beta Walls',
  collection: 'Nova',
  unit: 'рул',
  texture: 'sand',
  duplicateWarning: 'Одинаковый артикул найден у нескольких канонических товаров',
  supplierCount: 1,
  warehouseCount: 1,
  offers: [
    {
      id: 'a-beta-c',
      supplierId: 'supplier-c',
      supplierName: 'Поставщик C',
      supplierSku: 'A7712-BETA',
      warehouse: 'Склад 1',
      purchase: { amount: 1525, currency: 'RUB' },
      rrp: { amount: 2410, currency: 'RUB' },
      free: { amount: 2, unit: 'рул' },
      expected: { amount: 20, unit: 'рул' },
      freshness: 'aging',
      freshnessLabel: 'Давно не обновлялось',
      freshnessDetail: 'Последнее обновление 12 августа 2026, 08:02. Значение приближается к порогу устаревания.',
      observedAt: '12.08.2026 08:02',
    },
  ],
};

export const catalogFixtures: Record<string, CanonicalCatalogItem[]> = {
  R28003: [r28003],
  A7712: [a7712Alpha, a7712Beta],
};

export function mockCatalogSearch(query: string): CatalogSearchResult {
  const normalized = query.trim().toUpperCase();
  return {
    query: normalized,
    items: catalogFixtures[normalized] ?? [],
    mockNotice: 'Демонстрационные данные — не производственная информация',
  };
}

export const tenantSupplierFixtures: TenantSupplierSummary[] = [
  {
    id: 'surgaz',
    name: 'Surgaz',
    integrationMethod: 'API поставщика / адаптер DataSota',
    lastSuccessfulUpdate: '12.08.2026 09:42',
    health: 'current',
    healthLabel: 'Актуально',
    healthDetail: 'Основной API-канал завершил загрузку без ошибок. XML/WebDAV указан только как fallback/reference.',
    safeErrorState: 'При ошибке показываются последние успешные данные с явной отметкой времени.',
    capabilities: ['Каталог', 'Цены', 'Остатки', 'Ожидаемые поставки', 'changed-since', 'Пакетные загрузки'],
    productCount: 18422,
    warehouseCount: 2,
    mappingCoveragePercent: 98.7,
    mappingCoverageLabel: '98,7% сопоставлено',
    needsAttention: 239,
    fallbackReference: 'XML/WebDAV · только fallback/reference',
    warehouses: [
      { id: 'surgaz-msk', name: 'Москва', state: 'current', stateLabel: 'Актуально', lastSuccessfulUpdate: '12.08.2026 09:42' },
      { id: 'surgaz-spb', name: 'Санкт-Петербург', state: 'current', stateLabel: 'Актуально', lastSuccessfulUpdate: '12.08.2026 09:42' },
    ],
    recentImports: [
      { id: 'surgaz-import-1', startedAt: '12.08.2026 09:42', result: 'success', objectCount: 18422, note: 'Каталог, цены, остатки' },
      { id: 'surgaz-import-2', startedAt: '12.08.2026 08:10', result: 'success', objectCount: 18417, note: 'Инкрементальное changed-since обновление' },
      { id: 'surgaz-import-3', startedAt: '12.08.2026 06:40', result: 'error', objectCount: null, note: 'Временная ошибка источника; последние успешные данные сохранены' },
    ],
  },
  {
    id: 'supplier-b',
    name: 'Поставщик B',
    integrationMethod: 'DataSota standard',
    lastSuccessfulUpdate: '12.08.2026 09:31',
    health: 'current',
    healthLabel: 'Актуально',
    healthDetail: 'Стандартный адаптер DataSota завершил обновление без ошибок.',
    safeErrorState: 'При ошибке текущие значения не подменяются; сохраняется последняя успешная версия.',
    capabilities: ['Каталог', 'Цены', 'Остатки'],
    productCount: 12980,
    warehouseCount: 1,
    mappingCoveragePercent: 94.3,
    mappingCoverageLabel: '94,3% сопоставлено',
    needsAttention: 740,
    warehouses: [{ id: 'supplier-b-main', name: 'Основной склад', state: 'current', stateLabel: 'Актуально', lastSuccessfulUpdate: '12.08.2026 09:31' }],
    recentImports: [
      { id: 'supplier-b-import-1', startedAt: '12.08.2026 09:31', result: 'success', objectCount: 12980, note: 'Полное обновление каталога' },
      { id: 'supplier-b-import-2', startedAt: '12.08.2026 07:30', result: 'success', objectCount: 12974, note: 'Цены и остатки' },
    ],
  },
  {
    id: 'supplier-c',
    name: 'Поставщик C',
    integrationMethod: 'Файловый / custom adapter',
    lastSuccessfulUpdate: '12.08.2026 07:08',
    health: 'stale',
    healthLabel: 'Устарело',
    healthDetail: 'Последняя успешная загрузка старше рабочего порога; показаны последние известные данные.',
    safeErrorState: 'Устаревшие данные помечаются и не выдаются за текущие.',
    capabilities: ['Каталог', 'Цены', 'Остатки'],
    productCount: 8640,
    warehouseCount: 1,
    mappingCoveragePercent: 87.5,
    mappingCoverageLabel: '87,5% сопоставлено',
    needsAttention: 1080,
    warehouses: [{ id: 'supplier-c-1', name: 'Склад 1', state: 'stale', stateLabel: 'Устарело', lastSuccessfulUpdate: '12.08.2026 07:08' }],
    recentImports: [
      { id: 'supplier-c-import-1', startedAt: '12.08.2026 07:08', result: 'success', objectCount: 8640, note: 'Файловый импорт завершён' },
      { id: 'supplier-c-import-2', startedAt: '12.08.2026 05:02', result: 'error', objectCount: null, note: 'Файл не появился в ожидаемое окно' },
    ],
  },
  {
    id: 'supplier-d',
    name: 'Поставщик D',
    integrationMethod: 'Файловый / custom adapter',
    lastSuccessfulUpdate: '11.08.2026 18:20',
    health: 'source_error',
    healthLabel: 'Ошибка источника',
    healthDetail: 'Текущая загрузка завершилась ошибкой. Интерфейс показывает только последние успешные данные от 11.08.2026 18:20.',
    safeErrorState: 'Ошибка источника не раскрывает технический ответ; доступны только последние успешные данные.',
    capabilities: ['Каталог', 'Цены', 'Остатки'],
    productCount: 5432,
    warehouseCount: 1,
    mappingCoveragePercent: 81.4,
    mappingCoverageLabel: '81,4% сопоставлено',
    needsAttention: 1010,
    warehouses: [{ id: 'supplier-d-1', name: 'Склад D1', state: 'source_error', stateLabel: 'Ошибка источника', lastSuccessfulUpdate: '11.08.2026 18:20' }],
    recentImports: [
      { id: 'supplier-d-import-1', startedAt: '12.08.2026 09:10', result: 'error', objectCount: null, note: 'Источник временно недоступен; секреты и технические ответы скрыты' },
      { id: 'supplier-d-import-2', startedAt: '11.08.2026 18:20', result: 'success', objectCount: 5432, note: 'Последняя успешная загрузка' },
    ],
  },
];

export const platformSupplierIntegrationFixtures: PlatformSupplierIntegration[] = [
  {
    id: 'platform-surgaz', supplier: 'Surgaz', integrationClass: 'API поставщика / адаптер DataSota',
    sourceMethod: 'API поставщика через адаптер DataSota', health: 'current', healthLabel: 'Актуально',
    healthDetail: 'Основной API-адаптер работает штатно.', lastSuccessfulIngest: '12.08.2026 09:42',
    capabilities: ['changed-since', 'Пакетные загрузки', 'Заказы · факт возможности', 'Краски'],
    adapterVersion: 'surgaz-adapter 0.9 mock', feedVersion: 'Supplier API v2 · reference',
    fallbackReference: 'XML/WebDAV · только fallback/reference',
  },
  {
    id: 'platform-standard-b', supplier: 'Поставщик B', integrationClass: 'DataSota standard',
    sourceMethod: 'Стандартный каталог DataSota', health: 'current', healthLabel: 'Актуально',
    healthDetail: 'Стандартный ingest завершён без ошибок.', lastSuccessfulIngest: '12.08.2026 09:31',
    capabilities: ['Каталог', 'Цены', 'Остатки'], adapterVersion: 'standard-adapter 1.4 mock',
  },
  {
    id: 'platform-file-c', supplier: 'Поставщик C', integrationClass: 'Файловый / custom adapter',
    sourceMethod: 'Файловая поставка через custom adapter', health: 'stale', healthLabel: 'Устарело',
    healthDetail: 'Последний успешный ingest старше рабочего порога.', lastSuccessfulIngest: '12.08.2026 07:08',
    capabilities: ['Каталог', 'Цены', 'Остатки'], adapterVersion: 'file-custom 0.7 mock',
    feedVersion: 'CSV schema 3 · reference',
  },
];

export const mappingFixtures: MappingRecord[] = [
  { id: 'map-1001', supplier: 'Surgaz', supplierProduct: 'Fipar Grand Classic', supplierArticle: 'R28003', proposedCanonical: 'Fipar Grand Classic R28003', canonicalArticle: 'R28003', state: 'suggested', evidence: ['Артикул совпадает', 'Бренд совпадает', 'Коллекция совпадает'] },
  { id: 'map-1002', supplier: 'Поставщик B', supplierProduct: 'Wallpaper Alpha', supplierArticle: 'A7712', proposedCanonical: 'Wallpaper Alpha', canonicalArticle: 'A7712', state: 'issue', evidence: ['Артикул неоднозначен', 'Найдено 2 канонических товара'], issueState: 'open' },
  { id: 'map-1003', supplier: 'Поставщик C', supplierProduct: 'Fipar R28003', supplierArticle: 'R-28003', proposedCanonical: 'Fipar Grand Classic R28003', canonicalArticle: 'R28003', state: 'confirmed', evidence: ['Подтверждено ответственным за сопоставления', 'Артикул поставщика нормализован'] },
  { id: 'map-1004', supplier: 'Поставщик D', supplierProduct: 'Unknown wallcovering', supplierArticle: 'W-909', proposedCanonical: 'Не определено', canonicalArticle: '—', state: 'rejected', evidence: ['Недостаточно признаков'] },
];

export const tenantUsers: TenantUser[] = [
  { id: 'user-1', name: 'Анна Круглова', email: 'anna@mosoboi.example', role: 'Владелец', state: 'active', stateLabel: 'Активен', mfa: 'Включена', updatedAt: '12.08.2026' },
  { id: 'user-2', name: 'Михаил Орлов', email: 'm.orlov@mosoboi.example', role: 'Менеджер', state: 'inactive', stateLabel: 'Неактивен', mfa: 'Настроена', updatedAt: '08.08.2026' },
  { id: 'user-3', name: 'Елена Миронова', email: 'elena@mosoboi.example', role: 'Ответственный за сопоставления', state: 'pending', stateLabel: 'Ожидает одобрения DataSota', mfa: 'Не начата', updatedAt: '12.08.2026' },
  { id: 'user-4', name: 'Павел Сорокин', email: 'pavel@mosoboi.example', role: 'Логист', state: 'rejected', stateLabel: 'Отклонён / история', mfa: 'Не настроена', updatedAt: '04.08.2026' },
];

export const accessRequests: AccessRequest[] = [
  { id: 'req-1', tenant: 'Мособои', company: 'ООО Мособои', employeeName: 'Елена Миронова', employeeEmail: 'elena@mosoboi.example', requestedRole: 'Ответственный за сопоставления', requester: 'Анна Круглова · Владелец', requestedAt: '12.08.2026 09:55', state: 'in_review', stateLabel: 'На проверке' },
  { id: 'req-2', tenant: 'WallPro', company: 'ООО ВоллПро', employeeName: 'Сергей Романов', employeeEmail: 'sergey@wallpro.example', requestedRole: 'Логист', requester: 'Ольга Власова · Владелец', requestedAt: '12.08.2026 09:20', state: 'new', stateLabel: 'Новый' },
  { id: 'req-3', tenant: 'Decor Hub', company: 'Декор Хаб', employeeName: 'Марина Котова', employeeEmail: 'marina@decor.example', requestedRole: 'Менеджер', requester: 'Ирина Белова · Владелец', requestedAt: '11.08.2026 16:10', state: 'approved', stateLabel: 'Подтверждено' },
  { id: 'req-4', tenant: 'Тест 1', company: 'Тестовая компания', employeeName: 'Иван Иванов', employeeEmail: 'test@example', requestedRole: 'Менеджер', requester: 'Тестовый владелец', requestedAt: '10.08.2026 11:05', state: 'rejected', stateLabel: 'Отклонено' },
];

export const commercialAccess: CommercialAccess[] = [
  { id: 'comm-1', tenant: 'Внутренний стенд', state: 'Внутренний тест', effectiveFrom: '01.08.2026', lastChangedAt: '01.08.2026 10:00', administrativeAction: 'Завершить внутренний тест' },
  { id: 'comm-2', tenant: 'WallPro', state: 'Пробный период', effectiveFrom: '10.08.2026', expiresAt: '24.08.2026', lastChangedAt: '10.08.2026 09:15', administrativeAction: 'Продлить пробный период' },
  { id: 'comm-3', tenant: 'Decor Hub', state: 'Активная подписка', effectiveFrom: '01.08.2026', expiresAt: '31.08.2026', lastChangedAt: '01.08.2026 08:30', administrativeAction: 'Приостановить' },
  { id: 'comm-4', tenant: 'Партнёрский шоурум', state: 'Бесплатный доступ вручную', effectiveFrom: '05.08.2026', lastChangedAt: '05.08.2026 13:40', administrativeAction: 'Отозвать бесплатный доступ' },
  { id: 'comm-5', tenant: 'Мособои', state: 'Доступ приостановлен', effectiveFrom: '01.08.2026', lastChangedAt: '12.08.2026 08:05', administrativeAction: 'Возобновить' },
  { id: 'comm-6', tenant: 'Тест 1', state: 'Отключён', lastChangedAt: '11.08.2026 17:20', administrativeAction: 'Восстановить доступ' },
];

export const supportGrants: SupportGrant[] = [
  { id: 'grant-active', tenant: 'Мособои', operator: 'Поддержка DataSota', expiresAt: '12.08.2026 11:30', state: 'active' },
  { id: 'grant-expired', tenant: 'WallPro', operator: 'Поддержка DataSota', expiresAt: '11.08.2026 17:00', state: 'expired' },
  { id: 'grant-revoked', tenant: 'Decor Hub', operator: 'Поддержка DataSota', expiresAt: '12.08.2026 12:00', state: 'revoked' },
];
